<template>
  <div class="search-bar">
    <form
      class="search-bar__form form-group col xs-span l4-9"
      :action="$variable('routes.search-url')"
      method="get"
      role="search"
    >
      <div class="search-bar__wrapper form-group__field">
        <label
          class="visually-hidden"
          for="search-bar"
          v-text="$string('search.search_placeholder')"
        />

        <input
          id="search-bar"
          ref="search-bar"
          class="search-bar__input"
          name="q"
          required
          type="search"
          :value="query"
          :placeholder="$string('search.search_placeholder')"
        >

        <btn
          class="search-bar__submit"
          :label="$string('search.submit')"
          modifiers="primary"
          type="submit"
          show-icon
        >
          <template #icon>
            <icon-search />
          </template>
        </btn>
      </div>
    </form>

    <p
      v-if="productCount > 0"
      class="search-bar__results text-body-l-regular text-heading-m-desktop"
      v-text="$string('search.result_count', {
        replace: {
          count: productCount,
          term: query
        },
        pluralise: productCount
      })"
    />

    <p
      v-else-if="showNoResultsMessage"
      class="search-bar__empty text-body-l-regular text-heading-m-desktop"
      v-text="$string('collection.no_results')"
    />
  </div>
</template>

<script>

/**
 * Vue: Search bar (search-bar)
 * -----------------------------------------------------------------------------
 * Search bar UI on search page.
 *
 * @param {String} query - Search query.
 * @param {Number} productCount - Number of product results.
 */
import Btn from '~global/btn/btn.vue'
import IconSearch from '~icons/general/search.svg'

export default {
  name: 'SearchBar',

  components: {
    Btn,
    IconSearch,
  },

  props: {
    query: {
      type: String,
      default: '',
    },
    productCount: {
      type: Number,
      default: 0,
    },
  },

  computed: {

    /**
     * Whether to show 'no results' message.
     * @returns {Boolean}
     */
    showNoResultsMessage() {
      return this.query && !this.productCount > 0
    },
  },

  mounted() {
    this.$refs['search-bar'].focus()
  },
}
</script>

<style lang="scss">
@import './search-bar';
</style>
